import '@/styles/quill.css'

import { useTheme } from '@mui/material'
import { forwardRef, useImperativeHandle, useMemo, useRef } from 'react'
import ReactQuill, { QuillOptionsStatic } from 'react-quill-new'

interface QuillProps {
  value: string
  onChange: (content: string) => void
}

const Quill = forwardRef<ReactQuill, QuillProps>((props, ref) => {
  const { value, onChange } = props
  const {
    palette: { mode },
  } = useTheme()

  const innerRef = useRef<ReactQuill>(null)

  useImperativeHandle(ref, () => innerRef.current as ReactQuill)

  const quillModules: QuillOptionsStatic['modules'] = useMemo(
    () => ({
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        ['link', 'image', 'video', 'formula'],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ['clean'],
      ],
      clipboard: {
        matchVisual: false,
        matchers: [
          [
            Node.ELEMENT_NODE,
            (_: HTMLElement, delta: any) => {
              delta.ops = delta.ops.map((op: any) => {
                if (op.attributes) {
                  delete op.attributes.background
                  delete op.attributes.color
                  delete op.attributes.font
                  delete op.attributes.size
                }
                return op
              })
              return delta
            },
          ],
        ],
      },
    }),
    [],
  )

  return (
    <div
      className={`quill-editor ${mode === 'dark' ? 'dark-theme' : ''}`}
      style={{
        borderRadius: 4,
        overflow: 'hidden',
        border: '1px solid #ccc',
      }}>
      <ReactQuill
        ref={innerRef}
        value={value}
        onChange={onChange}
        modules={quillModules}
        placeholder="Digite aqui o seu texto..."
        theme="snow"
        style={{
          color: mode === 'dark' ? '#fff' : '#000',
          padding: 4,
        }}
      />
    </div>
  )
})

Quill.displayName = 'QuillEditor'

export default Quill
